import React, { useCallback, useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { Cell } from '../Cell';
import { Block } from '../../Block';
import Button from '../../Button';
import { Checkbox } from '../../Checkbox';
import { setBalconies } from '../../../redux/store';
import 'swiper/css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Mousewheel } from 'swiper/modules';

interface Props {
  data: any[];
}

export const SelectorBalconies = ({ data = [] }: Props) => {
  const dispatch = useDispatch();
  const [balconiesChk, setBalconiesChk] = useState<boolean[]>(Array(data.length).fill(false));
  const [qBalconies, setQBalconies] = useState(Array(data.length).fill(0));

  const showEl = useCallback(
    (el: any, i: number) => (
      <div className="relative lg:w-auto w-[180px]" key={JSON.stringify(el) + i}>
        <Cell
          active={qBalconies[i] > 0}
          title={el.title}
          className="bg-contain bg-[50%_60%] bg-white bg-no-repeat"
          style={{ backgroundImage: `url(${el.image_path})`, backgroundSize: '60%' }}
        />
        {qBalconies[i] ? (
          <div className="lg:top-4 top-3 left-1/2 -translate-x-1/2 absolute select-none flex items-center lg:gap-3 gap-2 font-bold font-Istok">
            <Button
              variant="minus"
              onClick={() => {
                if (qBalconies[i] > 0) {
                  setQBalconies((p) => p.map((el, idx) => (idx === i ? el - 1 : el)));
                }
                if (qBalconies[i] === 1) {
                  setBalconiesChk((p) => p.map((el, index) => (index === i ? false : el)));
                }
              }}
            />
            {qBalconies[i]}
            <Button
              variant="plus"
              onClick={() =>
                setQBalconies((p) => p.map((el, idx) => (idx === i ? (el < 1 ? el + 1 : el) : el)))
              }
            />
          </div>
        ) : null}
        <Checkbox
          onChange={(chk) => {
            setQBalconies((p) => p.map((el, idx) => (idx === i ? (chk ? 1 : 0) : el)));
            setBalconiesChk((prev) => prev.map((el, index) => (index === i ? !el : el)));
          }}
          checked={balconiesChk[i]}
          className="lg:top-4 top-3 lg:right-4 right-3 absolute"
        />
      </div>
    ),
    [balconiesChk, qBalconies],
  );

  useEffect(() => {
    const newData: any = {};
    qBalconies.forEach((el, i) => {
      if (el > 0) {
        newData[data[i].id] = el;
      }
    });
    dispatch(setBalconies(newData));
  }, [qBalconies]);

  useEffect(() => {
    setBalconiesChk(Array(data.length).fill(false));
    setQBalconies(Array(data.length).fill(0));
  }, []);

  if (!data?.length) return null;

  return (
    <Block>
      <div className="lg:text-[32px] text-[19px] lg:mb-6 mb-3">
        Выберите балкон/лоджию, которые планируете менять
      </div>
      <div className="lg:grid hidden grid-cols-4 gap-9">{data?.map((el, i) => showEl(el, i))}</div>
      <div className="lg:hidden block">
        <Swiper
          slidesPerView={'auto'}
          className={'cursor-grab active:cursor-grabbing select-none'}
          modules={[FreeMode, Mousewheel]}
          mousewheel={{ forceToAxis: true }}
          freeMode={{ enabled: true, sticky: false }}
        >
          {data?.map((el, i) => (
            <SwiperSlide className={`!w-auto mr-4 last:mr-0`} key={JSON.stringify(el)}>
              {showEl(el, i)}
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </Block>
  );
};
